import { BigNumber } from 'ethers'
import { DateTime } from 'luxon'
import { VESISConfig } from '~/types/config'

// patch to Thursday
export function patchExpiresDate(
	config: VESISConfig,
	expiresDate: DateTime
): DateTime {
	const { week } = config

	const patchedDate = BigNumber.from(expiresDate.toUnixInteger())
		.div(week)
		.mul(week)
	return DateTime.fromSeconds(patchedDate.toNumber())
}
